import { render, staticRenderFns } from "./RelatedPackages.vue?vue&type=template&id=3ac82e6c&lang=pug&"
import script from "./RelatedPackages.vue?vue&type=script&lang=ts&"
export * from "./RelatedPackages.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports